import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";

interface ProfileImageRequestEntry {
  affAbo: string;
  imageRefUrl: string;
}

export interface ProfileImageResponseEntry {
  affAbo: string;
  profileImage: string;
}

export interface ProfileImageRequest {
  abos: ProfileImageRequestEntry[];
  parties?: PartyImageRequest;
}

export interface PartyImageRequest {
  affAbo: string;
  partyData: PartyData[];
}

export interface PartyData {
  partyId: string;
  imageRefUrl: string;
}

export interface PartyImageResponseEntry {
  affAbo: string;
  partyId: string;
  profileImage: string;
}
export interface ProfileImageResponse {
  images: ProfileImageResponseEntry[];
  callResults: unknown[];
  partyImages: PartyImageResponseEntry[];
}

export const profileImageAPI = createApi({
  reducerPath: "profileImageAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getProfileImages: builder.mutation<ProfileImageResponse, ProfileImageRequest>({
      query: (params) => ({
        url: `/acc-action-report-v2-api/api/profile-images`,
        method: "POST",
        body: params,
      }),
      extraOptions: { urlBase: "apiCFBaseUrl" },
    }),
  }),
});

export const { useGetProfileImagesMutation } = profileImageAPI;
